import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7ccba049")

_pushScopeId("data-v-7ccba049")
const _hoisted_1 = {
  key: 0,
  class: "battle-squad"
}
const _hoisted_2 = {
  key: 1,
  class: "tip"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BattleList = _resolveComponent("BattleList")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (!_ctx.noBattleData && _ctx.boolFinishGetData)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.battleArray, (item, index) => {
            return (_openBlock(), _createBlock(_component_BattleList, {
              key: item.key + index,
              title: _ctx.$t('playType') + (index + 1) + ':' + item.key,
              list: item.value,
              hasData: item.hasData,
              fromRole: _ctx.fromRole
            }, null, 8, ["title", "list", "hasData", "fromRole"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.noBattleData && _ctx.boolFinishGetData)
      ? (_openBlock(), _createBlock("p", _hoisted_2, _toDisplayString(_ctx.$t('noBattleArray')), 1))
      : _createCommentVNode("", true),
    (!_ctx.boolFinishGetData)
      ? (_openBlock(), _createBlock(_component_Loading, { key: 2 }))
      : _createCommentVNode("", true)
  ], 64))
})